import { render, staticRenderFns } from "./Waitingcall.vue?vue&type=template&id=08552985"
import script from "./Waitingcall.vue?vue&type=script&lang=js"
export * from "./Waitingcall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports